import React from 'react'
import aboutimage from "../Images/aboutme.svg";

const AboutMe = () => {
  return (
    <div
    style={{height: "100vh"}}
          className="row  overflow-hidden my-5"
         
          id="About_me"
        >
          <div className="col-md-6 main_see2 ">
            <img
              src={aboutimage}
              alt=""
              className="svgCotnact"
              data-aos-duration="1000"
              data-aos="zoom-in-down"
            />
          </div>
          <div className="col-md-6 main_see3">
            <div
              className="about__secc"
              data-aos-duration="1000"
              data-aos="zoom-in-left"
            >
              <h1 className="About_heading">About Me</h1>
              <h1 className=" mt-4">
                Hello, I'm <span>Hamza Farooq</span>
              </h1>
              <p className="text-justify mt-4" style={{ fontSize: "16px" }}>
                As a seasoned Frontend Developer with two years of experience at
                TechCreator Software, based in Swabi (KPK), I have successfully
                developed responsive and pixel-perfect websites. My expertise
                lies in crafting visually appealing and user-friendly interfaces
                that seamlessly adapt to various devices and screen sizes.
              </p>
            </div>
          </div>
        </div>
  )
}

export default AboutMe
